import React from 'react';
import PropTypes from 'prop-types';

import FormError from "src/core/gd-form/common/form-error/form-error";
import FormRowFlex from "../../../gd-form/form/form-flex/row"
import ItemsListEditorFormElement from "core/gd-ui/items-list-editor/items-list-editor-form-element";

export default function CustomFieldItemsList(props) {
    return (
        <FormRowFlex label="Options">
            <ItemsListEditorFormElement form={props.form}
                                        name="listItems"
                                        incSeedName="listItemsIncSeed"
                                        colorSelectionEnabled={true}/>
            <FormError form={props.form} name="listItems" />
        </FormRowFlex>
    );
}

CustomFieldItemsList.propTypes = {
    form: PropTypes.object
}